export default "__VITE_ASSET__HU2Q_Wlo__"